import { render, staticRenderFns } from "./formPemenuhan4.vue?vue&type=template&id=a8d6bc82&"
import script from "./formPemenuhan4.vue?vue&type=script&lang=js&"
export * from "./formPemenuhan4.vue?vue&type=script&lang=js&"
import style0 from "./formPemenuhan4.vue?vue&type=style&index=0&id=a8d6bc82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports